  // Gallery image switcher
  function bfSwitchImage(thumb) {
    var mainImg = document.getElementById('bf-main-image');
    if (!mainImg) return;
    mainImg.src = thumb.getAttribute('data-full');
    var thumbs = thumb.parentNode.querySelectorAll('.bf-gallery-thumb');
    for (var i = 0; i < thumbs.length; i++) {
      thumbs[i].classList.remove('active');
    }
    thumb.classList.add('active');
    // Update dots
    var dots = document.querySelectorAll('.bf-gallery-dot');
    var idx = Array.prototype.indexOf.call(thumbs, thumb);
    for (var j = 0; j < dots.length; j++) {
      dots[j].classList.toggle('active', j === idx);
    }
  }

  // Mobile swipe on gallery (horizontal only, ignores vertical scroll)
  (function() {
    var img = document.getElementById('bf-main-image');
    if (!img) return;
    var thumbs = document.querySelectorAll('.bf-gallery-thumb');
    if (!thumbs.length) return;
    var idx = 0;
    var startX = 0, startY = 0;
    img.addEventListener('touchstart', function(e) {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    }, {passive:true});
    img.addEventListener('touchend', function(e) {
      var dx = e.changedTouches[0].clientX - startX;
      var dy = e.changedTouches[0].clientY - startY;
      // Only trigger if horizontal movement is dominant and significant
      if (Math.abs(dx) < 60 || Math.abs(dy) > Math.abs(dx)) return;
      if (dx < 0) idx = Math.min(idx + 1, thumbs.length - 1);
      else idx = Math.max(idx - 1, 0);
      bfSwitchImage(thumbs[idx]);
    }, {passive:true});
  })();

  // Bundle selector — switches Shopify variant
  function bfSelectBundle(el) {
    var options = document.querySelectorAll('.bf-bundle-option');
    for (var i = 0; i < options.length; i++) {
      options[i].classList.remove('selected');
      options[i].setAttribute('aria-checked', 'false');
    }
    el.classList.add('selected');
    el.setAttribute('aria-checked', 'true');
    var variantId = el.getAttribute('data-variant-id');
    document.getElementById('bf-variant-id').value = variantId;
    var cartPriceEl = document.getElementById('bf-cart-price');
    if (cartPriceEl) {
      var priceText = el.querySelector('.bf-bundle-price');
      if (priceText) cartPriceEl.textContent = priceText.textContent;
    }
    // Update hero price display
    var currentPrice = el.querySelector('.bf-bundle-price');
    var comparePrice = el.querySelector('.bf-bundle-compare');
    var savePct = el.querySelector('.bf-bundle-save');
    var heroPrice = document.getElementById('bf-current-price');
    var heroCompare = document.getElementById('bf-compare-price');
    var saveBadge = document.getElementById('bf-save-badge');
    var oug18Box = document.getElementById('bf-oug18');
    var oug18Price = document.getElementById('bf-oug18-price');
    if (heroPrice && currentPrice) heroPrice.textContent = currentPrice.textContent;
    // Bundle-uri fără compare_at_price (ex. 2x/3x) nu au reducere reală —
    // ascunde badge/compare/disclaimer în loc să lase valorile vechi de la 1x
    if (heroCompare) {
      if (comparePrice) {
        heroCompare.textContent = comparePrice.textContent;
        heroCompare.style.display = '';
      } else {
        heroCompare.style.display = 'none';
      }
    }
    if (saveBadge) {
      if (savePct) {
        saveBadge.textContent = savePct.textContent;
        saveBadge.style.display = '';
      } else {
        saveBadge.style.display = 'none';
      }
    }
    if (oug18Box) {
      if (comparePrice && currentPrice) {
        oug18Box.style.display = '';
        if (oug18Price) oug18Price.textContent = currentPrice.textContent;
      } else {
        oug18Box.style.display = 'none';
      }
    }
    var stickyId = document.getElementById('bf-variant-id-sticky');
    if (stickyId) stickyId.value = variantId;
    var stickyPrice = document.getElementById('bf-sticky-price');
    if (stickyPrice) { var pt = el.querySelector('.bf-bundle-price'); if (pt) stickyPrice.textContent = pt.textContent; }
  }

  // Sticky ATC
  (function() {
    var sticky = document.getElementById('bf-sticky-atc');
    var heroBtn = document.querySelector('.bf-hero .bf-add-to-cart');
    if (!sticky || !heroBtn) return;
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) sticky.classList.add('bf-sticky-visible');
        else sticky.classList.remove('bf-sticky-visible');
      });
    }, { threshold: 0 });
    observer.observe(heroBtn);
  })();

  // FAQ toggle
  function bfToggleFaq(btn) {
    var item = btn.parentNode;
    var isOpen = item.classList.toggle('open');
    btn.setAttribute('aria-expanded', isOpen);
  }

  // Scroll animations
  (function() {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('bf-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    document.addEventListener('DOMContentLoaded', function() {
      var elements = document.querySelectorAll('.bf-fade-up');
      elements.forEach(function(el) {
        observer.observe(el);
      });
    });
  })();

